import React, { Component } from 'react';

export default class ValidationMessage extends Component {
    render() {
        return (
            <div>
                <p>Please complete the following items in order to proceed:</p>
                <ul className="validation-list">
                    {this.props.items.map(item => {
                        let isNum = parseInt(item);

                        return <li key={'qva' + item}>{isNum ? 'Question ' + item : item}</li>
                    })}
                </ul>
            </div>
        );
    }
}
